export interface ICategorie {
  id?: number;
  libelle?: string;
  etat?: any;
}
export class Categorie implements ICategorie {
  constructor(public id?: number, public libelle?: string, public etat?: any) {}
}
